import { render, staticRenderFns } from "./CollectionGeneral.vue?vue&type=template&id=df79776e&"
import script from "./CollectionGeneral.vue?vue&type=script&lang=js&"
export * from "./CollectionGeneral.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports